import { render, staticRenderFns } from "./AppRetrievedEmailVerification.vue?vue&type=template&id=974f8cb0&scoped=true&"
import script from "./AppRetrievedEmailVerification.vue?vue&type=script&lang=ts&"
export * from "./AppRetrievedEmailVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AppRetrievedEmailVerification.vue?vue&type=style&index=0&id=974f8cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974f8cb0",
  null
  
)

export default component.exports